import type { ReleaseMark } from '@/admin/dashboards/chartViewModel';

/** Demo release markers that fall inside the contract fixture weekly window (~2026-10). */
export const DEMO_AI_TUTOR_RELEASE_LINES: ReleaseMark[] = [
  {
    at: '2026-10-06T12:00:00Z',
    prompt: 'Judge v2',
  },
  {
    at: '2026-10-10T12:00:00Z',
    prompt: 'Feedback v3',
  },
];

type MetricsWithReleaseContext = {
  context?: object | null;
};

/** Returns a copy of the metrics payload with demo release lines for charts and Visual Lab. */
export function withDemoReleaseLines<T extends MetricsWithReleaseContext>(response: T): T {
  const context = response.context ?? {};
  return {
    ...response,
    context: {
      ...context,
      releaseLines: DEMO_AI_TUTOR_RELEASE_LINES,
    },
  };
}
